<div class="md:flex hidden flex-none w-52">
	{{ controller.i18n + '.table.column.date' | translate }}
</div>
<div class="md:flex hidden flex-1">
	{{ controller.i18n + '.table.column.note' | translate }}
</div>
<div class="md:flex hidden flex-none w-10"></div>
